import React, { useState, useEffect } from "react";
import "../styles/ImageSlider.css";

const images = [
  { src: require("../assets/images/slider-acb-panel-board.jpeg"), name: "ACB Reparing Services" },
  { src: require("../assets/images/vcb.jpg"), name: "VCB Reparing Services" },
  { src: require("../assets/images/mccb.jpg"), name: "MCCB Reparing Services" },
  { src: require("../assets/images/LTHTPanels.jpg"), name: "TL/HT Electrical Panels" },
  { src: require("../assets/images/transformer.jpg"), name: "Electrical Transformer Services" },
  { src: require("../assets/images/retrofitting.jpg"), name: "Retrofitting" }
];

const ImageSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const goToPrev = () => {
    setCurrent(current === 0 ? images.length - 1 : current - 1);
  };

  const goToNext = () => {
    setCurrent(current === images.length - 1 ? 0 : current + 1);
  };

  return (
    <div className="slider-container">
      <button className="arrow left" onClick={goToPrev}>
        &#8592;
      </button>
      <div className="slider-content">
        <img src={images[current].src} alt={images[current].name} className="slider-image" />
        <div className="image-name">{images[current].name}</div>
      </div>
      <button className="arrow right" onClick={goToNext}>
        &#8594;
      </button>
    </div>
  );
};

export default ImageSlider;
